import { Button, Heading, Paragraph } from '@/components/atoms';
import { ChannelCard } from '@/components/atoms';
import { GiftIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router';
import { routes } from '@/lib/constants';
import { useOmnichannelConversationLists } from '@/hooks/use-omnichannel-conversation-lists';

export const Channels = () => {
  const { conversationsByChannel } = useOmnichannelConversationLists();

  const counts = {
    all:
      conversationsByChannel.facebook.length +
      conversationsByChannel.instagram.length +
      conversationsByChannel.whatsapp.length,
    whatsapp: conversationsByChannel.whatsapp.length,
    instagram: conversationsByChannel.instagram.length,
    facebook: conversationsByChannel.facebook.length,
  };
  return (
    <div className="grid grid-cols-12 gap-2.5 col-span-10 xl:col-span-2 xl:flex xl:flex-col">
      <ChannelCard
        chatCount={counts.whatsapp}
        variant="whatsapp"
        className="col-span-12 sm:col-span-4 md:col-span-6 lg:col-span-4 xl:col-span-12"
      />
      <ChannelCard
        chatCount={counts.instagram}
        variant="instagram"
        className="col-span-12 sm:col-span-4 md:col-span-6 lg:col-span-4 xl:col-span-12"
      />
      <ChannelCard
        chatCount={counts.facebook}
        variant="facebook"
        className="col-span-12 sm:col-span-4 md:col-span-6 lg:col-span-4 xl:col-span-12"
      />

      {/* Refer & Earn card */}
      <div className="bg-white rounded-md border border-accent col-span-12 sm:col-span-4 md:col-span-6 lg:col-span-4 xl:col-span-12 p-4 flex flex-col items-center gap-4">
        <div className="text-center">
          <Heading className="text-sm mb-2">Refer & Earn</Heading>
          <Paragraph className="text-xs text-muted-foreground mb-4">
            Earn up to ₦10,500 when vendors you invite start selling on Sellyt.
          </Paragraph>
        </div>

        {/* Gift box illustration */}
        <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-2">
          <GiftIcon className="w-8 h-8 text-primary" />
        </div>

        <Button
          asChild
          className="w-full flex items-center justify-center gap-2"
        >
          <Link to={routes.referAndEarn}>
            Refer now
            <ArrowRightIcon className="w-4 h-4" />
          </Link>
        </Button>
      </div>
    </div>
  );
};
